/* eslint-disable import/no-anonymous-default-export */
export default {
  "us": {
    "gameServers": "wss://server.plinko.elbet.us:8121/ws/plinko"
  },
  "retail": {
    "gameServers": "wss://server.plinko.elbet.com:8121/ws/plinko"
  },
  "default": {
    "gameServers": "wss://server.plinko.elbet.com:8121/ws/plinko"
  }
}